var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"text-center"},[_vm._v(" Need additional help? "),_c('a',{staticClass:"secondary--text font-weight-bold",attrs:{"href":"/training"}},[_vm._v(" Watch our tutorials ")])])
}]

export { render, staticRenderFns }